/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User screening statuses for background check and safety training services.
 * @export
 * @enum {string}
 */
export enum UserScreeningStatuses {
  Requested = 'Requested',
  InReview = 'In-Review',
  Approved = 'Approved',
  ApprovedManual = 'Approved (manual)',
  Declined = 'Declined',
  DeclinedManual = 'Declined (manual)',
  CreationPending = 'Creation Pending',
  Processing = 'Processing',
  Cancelled = 'Cancelled',
}

export function UserScreeningStatusesFromJSON(
  json: any
): UserScreeningStatuses {
  return UserScreeningStatusesFromJSONTyped(json, false)
}

export function UserScreeningStatusesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserScreeningStatuses {
  return json as UserScreeningStatuses
}

export function UserScreeningStatusesToJSON(
  value?: UserScreeningStatuses | null
): any {
  return value as any
}
